export enum ApiHealthStatus {
  HEALTHY = 'healthy',
  UNHEALTHY = 'unhealthy',
  DISABLED = 'disabled',
}
